<script>
  import SettingListAdd from "../Components/TriggerActions/SettingListAdd.svelte";
  import SettingListRemove from "../Components/TriggerActions/SettingListRemove.svelte";
  import SettingMembershipAdd from "../Components/TriggerActions/SettingMemberGroupAdd.svelte";
  import SettingMembershipRemove from "../Components/TriggerActions/SettingMemberGroupRemove.svelte";
  import SettingEmailOpen from "../Components/TriggerActions/SettingEmailOpen.svelte";
  import SettingEmailClick from "../Components/TriggerActions/SettingEmailClick.svelte";
  import SettingPageVisit from "../Components/TriggerActions/SettingPageVisit.svelte";
  import SettingTagAdd from "../Components/TriggerActions/SettingTagAdd.svelte";
  import SettingTagRemove from "../Components/TriggerActions/SettingTagRemove.svelte";
  import SettingPropertyChange from "../Components/TriggerActions/SettingPropertyChange.svelte";
  import SettingPurchaseMake from "../Components/TriggerActions/SettingPurchaseMake.svelte";
  import SettingOrderStatusChange from "../Components/TriggerActions/SettingOrderStatusChange.svelte";
  import SettingCheckCartAbandon from "../Components/TriggerActions/SettingCheckCartAbandon.svelte";
  import SettingAutomationGoalReached from "../Components/TriggerActions/SettingGoalReached.svelte";
  import { ignore } from "../../Common/tools";
  import SettingCommentReaction from '../Components/TriggerActions/SettingCommentReaction.svelte';
  import SettingPollReaction from '../Components/TriggerActions/SettingPollReaction.svelte';
  import SettingSelectVideo from '../Components/TriggerActions/SettingSelectVideo.svelte';
  import SettingVideoPortion from '../Components/TriggerActions/SettingVideoPortion.svelte';
  import { M } from '../../external.js'
  import SettingCircleEnrollment from '../Components/TriggerActions/SettingCircleEnrollment.svelte';
  import SettingCircleContentCompleted from '../Components/TriggerActions/SettingCircleContentCompleted.svelte';

  export let data;
  export let onChange = ignore;

  let valid = true;

  export function get() {
    return data;
  }

  export function isValid() {
    return valid;
  }
</script>

<div class="col20 f-left small-rules mb-25">
  {#if data.type === "LIST_ADD"}
    <SettingListAdd bind:data bind:valid {onChange} />
  {:else if data.type === "LIST_REMOVE"}
    <SettingListRemove bind:data bind:valid {onChange} />
  {:else if data.type === "MEMBER_GROUP_ADD"}
    <SettingMembershipAdd bind:data bind:valid {onChange} />
  {:else if data.type === "MEMBER_GROUP_REMOVE"}
    <SettingMembershipRemove bind:data bind:valid {onChange} />
  {:else if data.type === "EMAIL_OPEN"}
    <SettingEmailOpen bind:data bind:valid {onChange} />
  {:else if data.type === "EMAIL_CLICK"}
    <SettingEmailClick bind:data bind:valid {onChange} />
  {:else if data.type === "PAGE_VISIT"}
    <SettingPageVisit bind:data bind:valid {onChange} />
  {:else if data.type === "TAG_ADD"}
    <SettingTagAdd bind:data bind:valid {onChange} />
  {:else if data.type === "TAG_REMOVE"}
    <SettingTagRemove bind:data bind:valid {onChange} />
  {:else if data.type === "PROPERTY_CHANGE"}
    <SettingPropertyChange bind:data bind:valid {onChange} />
  {:else if data.type === "PURCHASE_MAKE"}
    <SettingPurchaseMake bind:data bind:valid {onChange} />
  {:else if data.type === "ORDER_STATUS_CHANGE"}
    <SettingOrderStatusChange bind:data bind:valid {onChange} />
  {:else if data.type === "CART_ABANDON"}
    <SettingCheckCartAbandon bind:data bind:valid {onChange} />
  {:else if data.type === "COMMENT_REACTION"}
    <SettingCommentReaction bind:data bind:valid onChange={onChange} />
  {:else if data.type === "POLL_REACTION"}
    <SettingPollReaction bind:data bind:valid onChange={onChange} />
  {:else if data.type === 'VIDEO_STARTED'}
    <SettingSelectVideo bind:data bind:valid {onChange} label={M.VIDEO_STARTED_AUTOMATION_DEFINITION} />
  {:else if data.type === 'VIDEO_PORTION_WATCHED'}
    <SettingVideoPortion bind:data bind:valid {onChange} />
  {:else if data.type === 'VIDEO_COMPLETED'}
    <SettingSelectVideo bind:data bind:valid {onChange} label={M.VIDEO_COMPLETED_AUTOMATION_DEFINITION} />
  {:else if data.type === 'CIRCLE_ENROLL'}
    <SettingCircleEnrollment bind:data bind:valid {onChange} />
  {:else if data.type === 'CIRCLE_CONTENT_COMPLETED'}
    <SettingCircleContentCompleted bind:data bind:valid {onChange} />
  {:else if data.type === "GOAL_REACHED"}
    <SettingAutomationGoalReached bind:data bind:valid {onChange} />
  {:else}{/if}
</div>
